import { RouteRecordRaw } from "vue-router";

const Account = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/Index.vue");
const AccountHome = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/Home.vue");
const AccountProfile = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/Profile.vue");
const AccountBilling = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/Billing.vue");
const AccountBillingInvoicesTable = () =>
  import(
    /* webpackChunkName: "account" */ "@/views/account/components/InvoicesTable.vue"
  );
const AccountBillingPaymentsTable = () =>
  import(
    /* webpackChunkName: "account" */ "@/views/account/components/PaymentsTable.vue"
  );
const AccountUsage = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/Usage.vue");
const AccountUsageSummary = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/UsageSummary.vue");
const AccountServiceUsage = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/ServiceUsage.vue");
const AccountNetworkEvents = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/NetworkEvents.vue");
const ReferFriend = () =>
  import(/* webpackChunkName: "account" */ "@/views/account/ReferFriend.vue");

const accountRoutes: Array<RouteRecordRaw> = [
  {
    path: "/account/:nickname",
    component: Account,
    children: [
      {
        path: "",
        component: AccountHome,
        meta: {
          title: "My account | Simply Broadband",
        },
      },
      {
        path: "profile",
        component: AccountProfile,
        meta: {
          title: "Profile | Simply Broadband",
        },
      },
      {
        path: "billing",
        name: "account-billing",
        component: AccountBilling,
        meta: {
          title: "Billing | Simply Broadband",
        },
        children: [
          {
            path: "",
            name: "account-billing-default",
            redirect: {
              name: "account-billing-invoices",
            },
          },
          {
            path: "invoices",
            name: "account-billing-invoices",
            component: AccountBillingInvoicesTable,
            meta: {
              title: "Billing | Simply Broadband",
              preserveScrollPosition: true,
            },
          },
          {
            path: "payments",
            name: "account-billing-payments",
            component: AccountBillingPaymentsTable,
            meta: {
              title: "Billing | Simply Broadband",
              preserveScrollPosition: true,
            },
          },
        ],
      },
      {
        path: "usage",
        component: AccountUsage,
        meta: {
          title: "Usage | Simply Broadband",
        },
        children: [
          {
            path: "summary",
            component: AccountUsageSummary,
            meta: {
              title: "Service Usage | Simply Broadband",
            },
          },
          {
            path: "service/:serviceId",
            component: AccountServiceUsage,
            meta: {
              title: "Service Usage | Simply Broadband",
            },
          },
        ],
      },
      {
        path: "network-events",
        component: AccountNetworkEvents,
        meta: {
          title: "Network Events | Simply Broadband",
        },
      },
      {
        path: "referral",
        component: ReferFriend,
        meta: {
          title: "Refer a friend | Simply Broadband",
        },
      },
    ],
  },
];

export default accountRoutes;
